
import Container from "~/components/atoms/Container";
import { Search } from "lucide-react";
import CustomPagination from "~/components/blocks/Pagination/Pagination";
import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationNext,
    PaginationPrevious,
} from "~/components/ui/custom-radix-components/pagination";

import { Input } from "~/components/ui/input";
import { LazyLoader } from "~/lib/utils/LazyLoader";
import FlatHeroBanner from "~/components/blocks/HeroBanners/FlatHeroBanner";
import { BlogCategoryTextHero } from "~/components/blocks/HeroBanners/BlogCategoryTextHero";
import NoResults from "../Card/NoResultCard";
import { getBlogChipMarketingHeroCopy } from "~/lib/constants/blogChipMarketingHero";
import { OhButton } from "~/components/ui/custom-radix-components/button";


interface MobileLayoutProps {
    title: string;
    renderBlogs: () => JSX.Element | JSX.Element[];
    handlePageChange: (page: number) => void;
    pageInfo: any;
    featuredBlogs: any;
    onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
    currentPage: number;
    noResults: boolean;
    clearFilters: () => void;
    searchText: string;
    country: string;
    marketingHero?: boolean;
    marketingHeroCopyKey?: string;
    selectedChip?: string;
}

export default function MobileLayout({ title, renderBlogs, handlePageChange, pageInfo, featuredBlogs, onSearch, currentPage, noResults, clearFilters, searchText, country, marketingHero = false, marketingHeroCopyKey, selectedChip }: MobileLayoutProps) {

    const heroKey = marketingHeroCopyKey ?? selectedChip;
    const marketingCopy = marketingHero && heroKey ? getBlogChipMarketingHeroCopy(heroKey) : null;

    return (
        <>
            <Container htmlFor='ultra-wide'>
                {marketingCopy ? (
                    <BlogCategoryTextHero
                        title={title}
                        description={marketingCopy.mobileDescription}
                    />
                ) : (
                    <FlatHeroBanner image={featuredBlogs?.blogs?.[0]?.bannerImageUrl} title={title} />
                )}


                {/* Search and Topics */}
                <div className="w-full px-4 py-6 bg-[#F4F6F9B2]">
                    <div className="flex justify-between mb-6">
                        <div className="flex items-center w-full max-w-lg h-[39px] rounded-lg border border-gray-600 overflow-hidden">
                            <Search className="ml-3 h-4 w-4 text-gray-500" />
                            <input
                                type="text"
                                placeholder="Search by title name or context"
                                className="w-full px-3 py-2 bg-white outline-none text-sm"
                                onChange={onSearch}
                                value={searchText}
                            />
                            <button className="bg-black text-white px-4 py-2 text-sm">SEARCH</button>
                        </div>
                    </div>

                    {/* Blog Grid */}
                    <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-col-4  gap-4 my-4">
                        {renderBlogs()}
                    </div>
                    {noResults &&
                        <div className="grid grid-cols-1 my-4">
                            <NoResults onClear={() => clearFilters()} />
                        </div>
                    }

                    {/* Pagination */}
                    {pageInfo?.totalPages > 1 && (
                        <div className="flex justify-center my-4">
                            <Pagination className="max-w-[550px] w-full justify-center">
                                <PaginationContent className="flex items-center">
                                    {currentPage > 1 ? (
                                        <PaginationItem className="cursor-pointer">
                                            <PaginationPrevious
                                                to="#"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            />
                                        </PaginationItem>
                                    ) : (<div className="w-[60px]" />)}
                                    <CustomPagination currentPage={currentPage} handlePageChange={handlePageChange} totalPages={pageInfo?.totalPages} />
                                    {currentPage < pageInfo?.totalPages ? (
                                        <PaginationItem className="cursor-pointer">
                                            <PaginationNext
                                                to="#"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            />
                                        </PaginationItem>
                                    ) : (<div className="w-[40px]" />)}
                                </PaginationContent>
                            </Pagination>
                        </div>
                    )}
                </div>


            </Container>

            <LazyLoader>
                <div
                    className="bg-cover bg-center py-16 px-4 text-white text-center"
                    style={{ backgroundImage: `url('${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/blogs/bg-banner.avif')` }}
                >
                    <h2 className="text-2xl font-bold mb-2">Subscribe to Office Hub’s Newsletter</h2>
                    <p className="mb-6">Get the best in industry news, delivered to your inbox.</p>
                    <div className="max-w-md mx-auto flex ">
                        <Input type="email" placeholder="Enter your email here" className="flex-1 rounded-tr-none rounded-br-none" />
                        <OhButton className="rounded-tl-none rounded-bl-none">Subscribe</OhButton>
                    </div>
                </div>
            </LazyLoader>

        </>
    );
}
